"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTADO_INICIAL = void 0;
exports.ESTADO_INICIAL = {
    pessoa: {},
    organizacao: {},
    usuarioFirebase: Object,
    autenticacaoLoading: true,
    necessarioAceitarTermos: false,
};
const getEstadoInicial = (organizacao) => {
    if (organizacao) {
        const novoEstado = Object.assign(Object.assign({}, exports.ESTADO_INICIAL), { organizacao });
        return novoEstado;
    }
    return exports.ESTADO_INICIAL;
};
exports.default = getEstadoInicial;
//# sourceMappingURL=estadoInicial.js.map